<template>
  <v-card class="pa-4 box_shadow_class main-card mt-0">
    <div>
      <div>
        <span>
          <HeaderComponent :headerTitle="headerText" />
        </span>
      </div>
      <v-row justify="center">
        <v-dialog v-model="conformationPopup" persistent max-width="500px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-spacer></v-spacer>
              <v-btn icon @click="conformationPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <div>The Data is Not available do you want to Preview</div>
              </v-container>
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="flat" color="primary" class="mb-3" @click="conformationPopup = false">OK</v-btn>
                <v-btn variant="flat" color="primary" class="mb-3" @click="navigatetoemptydashboard">Proceed</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-card class="v-card-100 pb-2" v-if="$isWhirlpoolClient()">
          <v-tabs color="primary" v-model="tab_index">
            <v-tab class="component-tab-heading" :class="{ 'active-tab': tab_index === index }" ripple :href="'#'" @click="active_tab = tab"
              style="text-transform:none!important;text-decoration: none; padding-top: 4px;" v-for="(tab, index) in ['MARS','RIMS']"
              :key="index">{{ tab }}</v-tab>
          </v-tabs>
      </v-card>
      <!-- <v-row v-if="active_tab === 'MARS Master' && $isWhirlpoolClient()" class="dynamic-hieght">
        <MarsMasterDashboard style="width:100%" />
      </v-row> -->
     <v-container class="ma-0 pa-0 overflow-y-auto overflow-x-hidden dynamic-hieght" v-if="active_tab == 'MARS' &&  $isWhirlpoolClient()" fluid grid-list-lg>
          <v-layout class="ma-0 pa-0" row wrap>
            <v-flex class xs12 style="background-color: grey lighten-3">
              <v-row class="margn">
             <v-col class="rounded-card" :elevation="4" v-for="(item,index) in mars_master_dashboard" :key="item">
                <v-card class="rounded-card" :elevation="4" style="width: 18vw;">
                    <router-link :to="{ name: 'MarsMasterDashboard', query: { 'generationName': item.name, 'mars_dashboard_id': item.id } }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="item.name.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ item.name.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">item.name</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  {{ item.name }}
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
      <v-container class="ma-0 pa-0 overflow-y-auto overflow-x-hidden dynamic-hieght" v-if="active_tab == 'RIMS' ||  !$isWhirlpoolClient()" fluid grid-list-lg>
        <v-layout class="ma-0 pa-0" row wrap>
          <v-flex class xs12 style="background-color: grey lighten-3">
            <v-row class="margn">
             <!-- <v-col :cols="getCols()" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'returngeneration', params: { generationName: 'Return Generation' } }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Return Generation'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Generation'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Generation</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Generation
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
              <!-- <v-col :cols="getCols()" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'returngenerationtrend' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                            <span class="font-weight-bold" v-if="'Return Generation Trend'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Generation Trend'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Generation Trend</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Generation Trend
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
             <!-- <v-col :cols="getCols()" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'ReturnProcessedvsGenerated' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                            <span class="font-weight-bold" v-if="'Return Generated vs Processed'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Generated vs Processed'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Generated vs Processed</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Generated vs Processed
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
              <!-- <v-col :cols="getCols()" class="rounded-card" :elevation="4">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'returnprocessedvsgeneratedtrend' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">                                
                                <span class="font-weight-bold" v-if="'Return Generated vs Processed Trend'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Generated vs Processed Trend'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Generated vs Processed Trend</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Generated vs Processed Trend
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
            <!-- </v-row> -->
            <!-- <v-row> -->
            <!-- not required fro Reliance -->
              <!-- <v-col xs3 cols="3" sm="3" md="3" v-if="organization_name != 'Reliance'">
                <router-link :to="{ name: 'PerUnitCost' }">
                  <v-card class="pa-4 box_shadow_class card_size">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/Overall.svg" width="60" height="60" />
                    </div>
                    <div class="mt-9 text-color" align="center" justify="center" id="4">5.Per Unit Cost</div>
                  </v-card>
                </router-link>
              </v-col> -->
              <!-- not required for Relenace -->
              <!-- <v-col xs3 cols="3" sm="3" md="3" v-if="organization_name != 'Reliance'">
                <router-link :to="{ name: 'ReverseLifecycleTAT' }">
                  <v-card class="pa-4 box_shadow_class card_size">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/Overall.svg" width="60" height="60" />
                    </div>
                    <div class="mt-9 text-color" align="center" justify="center" id="2">6. Reverse Lifecycle TAT</div>
                  </v-card>
                </router-link>
              </v-col> -->
              <!-- Not required fro reliance -->
              <!-- <v-col xs3 cols="3" sm="3" md="3" v-if="organization_name != 'Reliance'">
                <router-link :to="{ name: 'masterReportCard' }">
                  <v-card class="pa-4 box_shadow_class card_size">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/Overall.svg" width="60" height="60" />
                    </div>
                    <div class="mt-9 text-color" align="center" justify="center" id="6">7. Master Report Card</div>
                  </v-card>
                </router-link>
              </v-col> -->
              <!-- <v-col xs3 cols="3" sm="3" md="3" v-if="organization_name != 'Reliance' || organization_name != 'Voltas'">
                <v-card class="pa-4 box_shadow_class card_size" @click="checkAndNavigate(8)">
                  <div align="center" justify="center">
                    <img class="mt-3" src="@/assets/images/icons/dashboard.svg" width="60" height="60" />
                  </div>
                  <div class="mt-9 text-color" align="center" justify="center" >8. Empty Data 1</div>
                </v-card>
              </v-col> -->
              <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name === 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'ReturnInventoryDistribution' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Return Inventory Distribution'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Inventory Distribution'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Inventory Distribution</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Inventory Distribution
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
             <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name === 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'recovery' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Recovery</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
               <!-- <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'recoveryMethodDistribution' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Recovery Method Distribution'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Recovery Method Distribution'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Recovery Method Distribution</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Recovery Method Distribution
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
               <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'recoveryTrend' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Recovery Trend</span>                                
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
               <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name === 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'ReverseLifecycleTAT' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Reverse Lifecycle TAT'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Reverse Lifecycle TAT'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Reverse Lifecycle TAT</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Reverse Lifecycle TAT
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
              <v-col :cols="getCols()" class="rounded-card" :elevation="4"v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name === 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'ReverseLifecycleTatTrend' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Reverse Lifecycle TAT Trend'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Reverse Lifecycle TAT Trend'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Reverse Lifecycle TAT Trend</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Reverse Lifecycle TAT Trend
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
              <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'ReturnProcessingTrackier' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Return Processing Tracker'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Return Processing Tracker'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Return Processing Tracker</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Return Processing Tracker
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
             <v-col :cols="getCols()" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name != 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'PerUnitCost' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Per Unit Cost</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
              <!-- <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'masterReportCard' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Master Report Card</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
              <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'brandCallLogReportCard' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Brand Call Log Report Card'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Brand Call Log Report Card'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Brand Call Log Report Card</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Brand Call Log Report Card
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
              <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'liquidationReportCard' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Liquidation Report Card'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Liquidation Report Card'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Liquidation Report Card</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Liquidation Report Card
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
               <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'competitiveBiddingReportCard' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold" v-if="'Competitive Bidding Report Card (BEAM)'.length > 20">
                                  <v-tooltip location="bottom">
                                  <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on" class="font-weight-bold">
                                      {{ 'Competitive Bidding Report Card (BEAM)'.substring(0, 20) + '...' }}
                                    </span>
                                  </template>
                                  <span style="white-space: nowrap;">Competitive Bidding Report Card (BEAM)</span>
                                </v-tooltip>
                                </span>
                                <span class="font-weight-bold" v-else>
                                  Competitive Bidding Report Card (BEAM)
                                </span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center"style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col>
               <!-- <v-col xs3 cols="3" sm="3" md="3" class="rounded-card" :elevation="4" v-if="$isRelianceClient() || $isWhirlpoolClient() || organization_name != 'Voltas'">
                <v-card class="rounded-card" :elevation="4" >
                    <router-link :to="{ name: 'recoveryMethodDistribution' }">
                      <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;">
                          <v-col class="text-left p-0 d-flex" cols="8">
                            <img src="@/assets/images/icons/dashboard_icon12.png" max-width="18" max-height="18" alt="icon" class="ma-0 mr-2"></img>
                            <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                                <span class="font-weight-bold">Ageing</span>
                            </h4>
                          </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                          <v-col class="p-0">
                            <div class="text-center" style="cursor: pointer;">
                                <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px">
                                View
                                </a>
                            </div>
                          </v-col>
                      </v-row>
                    </router-link>
                </v-card>
              </v-col> -->
            </v-row>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
  import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess'
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        headerText: "Dashboard",
        conformationPopup : false,
        decodeURL:'',
        iframeUrl:'',
        organization_name:'',
        tab_index : 0,
        active_tab : 'MARS',
        username:'',
        mars_master_dashboard : [
          {
            name: 'Master',
            id: 18
          },
          // {
          //   name: 'Pending Status With Ageing',
          //   id: 19
          // },
          {
            name: 'Logistics Activity Performance',
            id: 20
          },
          {
            name: 'Logistics TAT Performance',
            id: 21
          },
          // {
          //   name: 'Logistics Cost Performance',
          //   id: 22
          // },
        ]
      };
    },
    created(){
         this.organization_name = this.$store.state.organization_name
        this.username = this.$store.state.username
        const role = this.$store.state.currentUser.roles[0]
        if(role in module_that_allowed && moduleAccessFunc(role,'Dashboard')){
          signout()
          return;
        }

        this.mars_master_dashboard = this.mars_master_dashboard.map(dashboard => {
          if (this.username === 'eurekaforbes' && dashboard.name === 'Master') {
            return { ...dashboard, name: 'Reverse Logistics Status' };
          }
          return dashboard;
        });

        if(this.username === 'whirpool_india' || this.username === 'whirlpool_rims' || this.username === 'whirlpool' || this.username === 'voltbek'){
          this.mars_master_dashboard.push({name: "Reverse Logistics Status", id:23},{name: "Return Units Warehouse", id:24})
        }
     },
    components: {
      HeaderComponent,
    },
    computed: mapState(["currentUser", "signedIn"]),
    methods: {
      checkAndNavigate(id) {
        this.$httpSecured
        .get(`/api/v2/dashboard/dashboard_embed_url?dashboard=${id}`)
        .then(response => {
          if (response.data && response.data.is_data_present === true) {
            this.iframeUrl = response.data.embed_url;
            this.decodeURL = decodeURI(this.iframeUrl)
            this.$router.push({ name: 'nodataavalable', query: { embed_url: this.decodeURL }  });
          } else {
            this.conformationPopup = true
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network: " + error);
        });
      },
      navigatetoemptydashboard(id) {
        this.$router.push({ name: "nodataavalable" });
      },
      getCols() {
         const width = window.innerWidth;
         if (width > 1600) {
           return 3;
         } else if (width > 1400) {
           return 4; 
         }
         return 4;
       },
       truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    },
    }

  };
</script>

<style scoped>
  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)>.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
    visibility: hidden;
  }
  .text-color {
    color: #0357d0;
    font-weight: 700;
    font-size: 18px;
  }
  .header-background {
    background-color: #0357d0;
  }
  .box_shadow_class {
    background: #ffffff;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 4px;
  }
  .card_size{
    height: 200px;
    width: 61vh;
  }
  .v-card-100 {
    max-width: 100% !important;
  }
  .margn {
    margin: 11px 0px 12px 0px;
  }
  .dynamic-hieght {
    height: calc(var(--vh, 1vh) * 100 - 139px) !important;
  }
  .active-tab {
    color: #1867C0 !important;
    border-bottom: 1px solid #1867C0;
  }
  .rounded-card{
        border-radius: 12px;
        overflow: hidden;
    }
    .sub_heading_css{
      font-size: 14px;
      font-weight: 600;
      line-height: 16.94px;
    }
    .bottom_border{
      border-bottom: 1px solid #E2E3ED;
    }
    .sub_header_value{
      font-size: 14px;
      font-weight: 400;
      line-height: 16.94px;
      color: #0C0C0C;
    }
</style>
